import { merchantIcons } from '@assets/icons';
import env from '@config/env';
import { ROUTE_PATHS } from '@config/routes';
import OnboardingPageLayout from '@modules/merchant/authentication/components/OnboardingPageLayout';
import RequestStatusCard from '@modules/merchant/onboarding/components/RequestStatusCard';
import { completeOnboarding } from '@redux/auth/authSlice';
import { fetchAppConfig } from '@redux/merchant/merchantSlice';
import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router';

const RequestSubmittedPage = memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const claimSubmitted = useSelector((state) => state.onboarding.businessSearch.claimSubmitted);

  useEffect(() => {
    document.title = `Request Submitted | ${env.APP_NAME}`;
  }, []);

  if (!claimSubmitted) {
    return <Navigate to={ROUTE_PATHS.SEARCH_BUSINESS} replace />;
  }

  const handleGoToDashboard = async () => {
    dispatch(completeOnboarding());
    await dispatch(fetchAppConfig());
    navigate(ROUTE_PATHS.SETUP_GUIDE);
  };

  return (
    <OnboardingPageLayout>
      <div className="flex w-full flex-col gap-page">
        <div className="flex w-full flex-col gap-form">
          <img
            src={merchantIcons.verify}
            alt=""
            className="size-12 shrink-0 md:size-[60px] desktop:size-20"
            aria-hidden="true"
          />

          <div className="flex w-full flex-col gap-1.5 desktop:gap-2">
            <h1 className="desktop:text-[24px] text-[20px] font-semibold leading-6 desktop:leading-8 text-merchant-text-primary">
              Request Submitted
            </h1>
            <p className="desktop:text-[16px] text-sm font-medium leading-4.5 desktop:leading-6 text-merchant-text-secondary">
              We&apos;ve received your request to manage this business. Our team will review the
              information and notify you once the verification process is complete.
            </p>
          </div>

          <RequestStatusCard />
        </div>

        <button
          type="button"
          onClick={handleGoToDashboard}
          className="w-full desktop:min-h-11 min-h-8 cursor-pointer rounded-full bg-merchant-action px-(--space-section) py-2.5 desktop:py-3 desktop:text-[16px] text-sm font-semibold leading-3.75 desktop:leading-5 text-white transition-opacity hover:opacity-90"
        >
          Go to Dashboard
        </button>
      </div>
    </OnboardingPageLayout>
  );
});

RequestSubmittedPage.displayName = 'RequestSubmittedPage';

export default RequestSubmittedPage;
